import React from 'react';
import PropTypes from 'prop-types';

import {
  STATUS,
  MODAL_RELEASE_TEXT,
  MODAL_HELD_TEXT,
} from '../constants';

import {
  Modal,
  ContainerButton,
  ButtonCancel,
  ButtonConfirm,
  Text,
  Content,
} from './styles';

const CustomModal = (props) => {
  const {
    onConfirm,
    onClose,
    open,
    loading,
    status,
  } = props;

  const isReleased = status === STATUS.RELEASED;
  const actionLabel = isReleased ? 'hold' : 'release';
  const message = isReleased ? MODAL_HELD_TEXT : MODAL_RELEASE_TEXT;

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Content>
        <Text>{message}</Text>

        <ContainerButton>
          <ButtonCancel
            onClick={onClose}
          >
            {`No, don't ${actionLabel}`}
          </ButtonCancel>
          <ButtonConfirm
            loading={loading}
            onClick={onConfirm}
          >
            {`Yes, ${actionLabel}`}
          </ButtonConfirm>
        </ContainerButton>
      </Content>
    </Modal>
  );
};

CustomModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
};

export default CustomModal;
